// extracted by mini-css-extract-plugin
module.exports = {"container":"disabled-form-page-module__container--blT3Q","message":"disabled-form-page-module__message--mPmDQ"};